import { render, staticRenderFns } from "./PatientModal__Style#Drawer.vue?vue&type=template&id=ba2ea522&scoped=true&"
import script from "./PatientModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./PatientModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./PatientModal__Style#Drawer.vue?vue&type=style&index=0&id=ba2ea522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2ea522",
  null
  
)

export default component.exports